export default __webpack_public_path__ + "static/media/AconteceNoParque.9e3b162e.svg";